var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Icon } from '../../../shared';
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import './section-menu.scss';
import { formTypeName } from '../../../../shared/types/constants';
import { ApplicationSectionStatus } from '../../../../shared/types/enums';
import { useLoader } from '../../../../shared/utils';
export var SectionMenu = function (_a) {
    var _b;
    var pages = _a.pages, rootPath = _a.rootPath, workflowName = _a.workflowName, location = _a.location, closeMenu = _a.closeMenu, activePageName = _a.activePageName;
    var _c = useState([]), openPages = _c[0], setOpenPages = _c[1];
    var sectionId = useParams().sectionId;
    var questionSetsSetIsLoading = useLoader({ identifier: 'questionSets' }).questionSetsSetIsLoading;
    var activePage = (_b = activePageName !== null && activePageName !== void 0 ? activePageName : sectionId) !== null && _b !== void 0 ? _b : window.location.pathname.split('/')[window.location.pathname.split('/').length - 1].toString();
    useEffect(function () {
        pages === null || pages === void 0 ? void 0 : pages.map(function (page) {
            var _a;
            if (((_a = page === null || page === void 0 ? void 0 : page.sections) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                if (page.sections.filter(function (section) { return section.id.toString() == activePage; }).length > 0) {
                    setOpenPages([page.id]);
                }
            }
        });
    }, [pages, activePage]);
    var setParentClasses = function (page) {
        var className = "c-section-menu-list__parent-link";
        if (page.applicationSectionStatus == ApplicationSectionStatus.Complete)
            className += ' isComplete';
        if (openPages.includes(page.id))
            className += ' toggled';
        return className;
    };
    var renderIcon = function (page, activePages) {
        return React.createElement(Icon, { size: "small", colour: "white", name: activePages.includes(page.id) ? 'arrowUp' : 'arrowDown' });
    };
    var toggleLink = function (e, id) {
        if (openPages.includes(id)) {
            var newOpenPages_1 = [];
            openPages.forEach(function (pageId) {
                if (pageId !== id)
                    newOpenPages_1.push(pageId);
            });
            setOpenPages(newOpenPages_1);
        }
        else {
            setOpenPages(__spreadArray(__spreadArray([], openPages, true), [id], false));
        }
    };
    var displayPages = workflowName == formTypeName.illustration ? pages === null || pages === void 0 ? void 0 : pages.slice(0, pages.length - 1) : pages;
    var formatDisplayName = function (name) {
        switch (name) {
            case 'Submit':
            case 'submit':
                return 'Your Submission';
            default:
                return name;
        }
    };
    return (React.createElement("section", { className: "c-section-menu" },
        React.createElement("header", { className: "c-section-menu__header" },
            React.createElement(Icon, { name: "progress", colour: "white" }),
            React.createElement("h3", null, workflowName),
            React.createElement("button", { onClick: function () { return closeMenu(false); } },
                React.createElement("span", null, "Close Menu"),
                React.createElement(Icon, { name: "close" }))),
        React.createElement("div", { className: "c-section-menu__body" },
            React.createElement("ol", { className: "c-section-menu-list" }, displayPages &&
                displayPages.map(function (page, pageIndex) {
                    var _a, _b, _c, _d;
                    return ((_a = page === null || page === void 0 ? void 0 : page.sections) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (React.createElement("li", { key: "page-".concat(page.id, "-").concat(pageIndex), className: "c-section-men-list__section ".concat(page.applicationSectionStatus == ApplicationSectionStatus.Complete && 'isComplete') },
                        React.createElement("button", { onClick: function (e) { return toggleLink(e, page.id); }, className: "".concat(setParentClasses(page), " with-child") },
                            renderIcon(page, openPages),
                            React.createElement("span", { className: "c-section-menu__label" }, page.name),
                            page.applicationSectionStatus == ApplicationSectionStatus.Complete && (React.createElement(Icon, { size: "small", name: "tick" }))),
                        React.createElement("ol", null, page &&
                            page.sections &&
                            page.sections.map(function (section, sectionIndex) {
                                var _a, _b, _c;
                                return (React.createElement("li", { key: "section-".concat(section.id, "-").concat(sectionIndex) },
                                    React.createElement(Link, { key: "section-link-".concat(section.id, "-").concat(sectionIndex), to: {
                                            pathname: "".concat(rootPath).concat(page.id, "/").concat(section.id),
                                            state: {
                                                loanPurposeId: (_a = location === null || location === void 0 ? void 0 : location.state) === null || _a === void 0 ? void 0 : _a.loanPurposeId,
                                                case: (_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.case,
                                                applicants: (_c = location === null || location === void 0 ? void 0 : location.state) === null || _c === void 0 ? void 0 : _c.applicants,
                                                pages: pages,
                                            },
                                        }, onClick: function () {
                                            section.id.toString() !== activePage && questionSetsSetIsLoading(true);
                                        }, className: "c-section-menu-list__child-link ".concat(section.applicationSectionStatus == ApplicationSectionStatus.Complete ||
                                            (!section.hasRequiredQuestions &&
                                                section.applicationSectionStatus == ApplicationSectionStatus.Partial)
                                            ? 'isComplete'
                                            : '', " ").concat(section.id.toString() == activePage ? 'active-menu' : '') },
                                        React.createElement("span", null),
                                        React.createElement("span", { className: "c-section-menu-list__label" }, section.name),
                                        (section.applicationSectionStatus == ApplicationSectionStatus.Complete ||
                                            (section.hasRequiredQuestions &&
                                                section.applicationSectionStatus == ApplicationSectionStatus.Partial)) && (React.createElement(Icon, { size: "small", name: "tick" })))));
                            })))) : (React.createElement("li", { key: "page-".concat(page.id, "-").concat(pageIndex), className: "c-section-men-list__section ".concat((page.applicationSectionStatus == ApplicationSectionStatus.Complete ||
                            page.applicationSectionStatus == ApplicationSectionStatus.Partial) &&
                            'isComplete') },
                        React.createElement(Link, { key: "page-link-".concat(page.id, "-").concat(pageIndex), to: {
                                pathname: "".concat(rootPath).concat(page.name),
                                state: {
                                    loanPurposeId: (_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.loanPurposeId,
                                    case: (_c = location === null || location === void 0 ? void 0 : location.state) === null || _c === void 0 ? void 0 : _c.case,
                                    applicants: (_d = location === null || location === void 0 ? void 0 : location.state) === null || _d === void 0 ? void 0 : _d.applicants,
                                    pages: pages,
                                },
                            }, onClick: function () {
                                page.name !== activePage && questionSetsSetIsLoading(true);
                            }, className: "".concat(setParentClasses(page), " ").concat(page.name == activePage ? 'active-menu' : '') },
                            React.createElement("span", { className: "c-section-menu__label" }, formatDisplayName(page.name)),
                            (page.applicationSectionStatus == ApplicationSectionStatus.Complete ||
                                page.applicationSectionStatus == ApplicationSectionStatus.Partial) && (React.createElement(Icon, { size: "small", name: "tick" })))));
                })))));
};
